var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M7.91336 4.23736C7.9409 4.2477 7.97027 4.25313 8 4.25313C8.06059 4.25313 8.11966 4.23057 8.16493 4.18995C8.16661 4.18812 8.1682 4.18639 8.1697 4.18478C8.17431 4.17983 8.17878 4.1752 8.18238 4.17152L8.18588 4.16759L8.74213 3.54259L8.75179 3.53173L8.75857 3.52495C9.59432 2.59527 10.8602 2.1674 12.0908 2.40265L12.0909 2.40267C13.7798 2.72593 15 4.20408 15 5.92188V6.025C15 7.05465 14.5702 8.04057 13.8152 8.74146L8.34024 13.8258L8 14.1417L7.65976 13.8258L2.18484 8.74146C1.42976 8.04057 1 7.05465 1 6.025V5.92188C1 4.2004 2.22072 2.72577 3.91236 2.40265L7.91336 4.23736ZM7.91336 4.23736L7.81004 4.15988L7.25787 3.53946L7.2482 3.5286L7.24451 3.52491M7.91336 4.23736L7.24451 3.52491M7.24451 3.52491C6.40554 2.59199 5.1427 2.16747 3.91245 2.40263L7.24451 3.52491ZM7.39852 14.2668L7.39853 14.2667L7.39478 14.2633L7.31837 14.193L7.31665 14.1914L1.84337 9.10862L1.8433 9.10856C0.986127 8.31281 0.5 7.19571 0.5 6.025V5.92188C0.5 3.96216 1.89169 2.2806 3.81869 1.91302L3.8197 1.91283C4.91473 1.7016 6.03598 1.95415 6.92994 2.58316C7.18208 2.76256 7.4161 2.96898 7.62726 3.20515L8.00405 3.62655L8.37629 3.20113C8.49055 3.07054 8.61375 2.94993 8.74662 2.83644L8.74662 2.83645L8.74895 2.83443C8.85334 2.74415 8.95866 2.66115 9.06798 2.58462L9.06909 2.58384C9.9632 1.95434 11.0853 1.70127 12.1815 1.90993C14.108 2.27751 15.5 3.9618 15.5 5.92188V6.025C15.5 7.19571 15.0139 8.31281 14.1567 9.10856L14.1566 9.10862L8.68335 14.1914L8.68163 14.193L8.60522 14.2633L8.60387 14.2645C8.43871 14.4176 8.22212 14.5031 8 14.5031C7.77516 14.5031 7.5606 14.419 7.39852 14.2668Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }